import { useAppUserQuery } from 'hooks/api/user/useAppUserQuery';

export const useUserIdSelector = () => {
  const userQuery = useAppUserQuery();

  return userQuery.data && userQuery.data.DATA.USER ? userQuery.data.DATA.USER.ID : 0;
};
